var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"multi-progress",style:(_vm.bgStyle),attrs:{"title":_vm.progressHint}},[_c('img',{staticClass:"multi-progress__mask",attrs:{"src":_vm.mask,"alt":"mask"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }